import LayoutAuth from 'layouts/auth/Index'
// import PageAuthLogin from 'pages/auth/Login'
import LayoutMain from 'layouts/main/Index'
import PageKlnInfo from 'pages/klnInfo/Info'
import PageKlnUserSelect from 'pages/klnUserSelect/UserSelect'
import PageKlnCategories from 'pages/klnCategories/Categoires'
import PageKlnQuizzes from 'pages/klnQuiz/Quiz'
import PageKlnResultInfo from 'pages/result/result'
import PageTimerCategories from 'pages/timerCategories/Categoires'
import PageTimerQuizzes from 'pages/klnTimerQuiz/TimerQuiz'
import PageKlnTimerInfo from 'pages/klnTimerInfo/Info'
import PageKlnResultTimerInfo from 'pages/resultTimer/result'

export default [
  { path: '', component: () => import('layouts/App'), children: [
    { path: '', name: 'login', component: LayoutAuth, children: [
      // { path: '', name: 'auth-login', icon: 'genderless', component: PageAuthLogin, },
    ], },
    { path: '', component: LayoutMain, children: [
      { path: 'kln/info', name: 'kln-info', icon: 'genderless', component: PageKlnInfo, },
      { path: 'kln/user', name: 'kln-user-select', icon: 'genderless', component: PageKlnUserSelect, },
      { path: 'kln/categories', name: 'kln-categories', icon: 'genderless', component: PageKlnCategories, },
      { path: 'kln/quizzes', name: 'kln-quizzes', icon: 'genderless', component: PageKlnQuizzes, },
      { path: 'kln/result', name: 'kln-result', icon: 'genderless', component: PageKlnResultInfo, },
      { path: 'kln/result-timer', name: 'kln-result-timer', icon: 'genderless', component: PageKlnResultTimerInfo, },
      { path: 'kln/timer-categories', name: 'kln-timer-categories', icon: 'genderless', component: PageTimerCategories, },
      { path: 'kln/timer-quizzes', name: 'kln-timer-quizzes', icon: 'genderless', component: PageTimerQuizzes, },
      { path: 'kln/info-timer', name: 'kln-timer-info', icon: 'genderless', component: PageKlnTimerInfo, },

    ], },
  ], },
]
